import { render, staticRenderFns } from "./HistoryDoctorDentist.vue?vue&type=template&id=646ac938&scoped=true&"
import script from "./HistoryDoctorDentist.vue?vue&type=script&lang=js&"
export * from "./HistoryDoctorDentist.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDoctorDentist.vue?vue&type=style&index=0&id=646ac938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ac938",
  null
  
)

export default component.exports